module.exports = __webpack_public_path__ + "media/images/careers/tech-a8c4953632e5e5c41bee138ff7465418.svg";